module.exports = __webpack_public_path__ + "static/media/dot_F50D0D_a.0a5146a8.svg";